import angular from 'angular';
/** Affiche les erreurs liées à l'inport d'un DO */
class modalErrorImportPrincipalCtrl {
    /*@ngInject*/
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
        this.modalErrorMessage = angular.copy(this.resolve.error);
    }

    ok() {
        this.modalInstance.close(true);
    }
}

angular.module('app.principal').component('modalErrorImportPrincipalCtrl', {
    templateUrl: require('./modal-error-import-principal.html'),
    controller: modalErrorImportPrincipalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
